import { useEffect, useState } from "react";
import { Str_Prohibition, Str_RemoveProhibition } from "../../../language/string_res";
import { TopicUserListRender } from "../TopicUsers";
import { useChatStore } from "../../../store/ChatStore";
import { User } from "../../../../imsdk/db/t_user";
import { groupBlackList } from "../../../net/service";
import { MainNavProps } from "../../navigation/main/MainParamList";
import { useIsFocused } from "@react-navigation/native";
import { postJson } from "../../../net/http";
import * as ImSdk from "../../../../imsdk/api";
import { showToast } from "../../../components/Toast";

export const GroupBlackAddOrRemove = ({ navigation, route }: MainNavProps<'GroupBlackAddOrRemove'>) => {
    const isRemove = route.params.isRemove
    const [users, updateUsers] = useState<User[]>([]);
    const { chatState } = useChatStore()
    const members = chatState.curTopicWithSummary.users ?? []
    const group = chatState.curTopicWithSummary.group
    const tid = chatState.curTopicWithSummary.topic.tid;
    const adminSet = chatState.adminSet ?? new Set<number>([])
    const isFocused = useIsFocused()
    const currentUid = ImSdk.getInstance().CurrentUid();
    useEffect(() => {
        if (isFocused) {
            isRemove ? initRemoveUserList() : initAddUserList();
        }
    }, [isFocused]);

    const initAddUserList = async () => {
        const ctrlUsers: User[] = [];
        const result = await groupBlackList({ tid })
        members.forEach((v) => {
            if (v.uid === currentUid) {
                // 不能自己
                return;
            }
            //如果在已经黑名单则不显示
            if (result.data && result.data.members.includes(v.uid)) {
                return;
            }

            if (v.uid === group?.uid) {
                //不能群主
                return;
            }
            if (currentUid === group?.uid) {
                // 群主可以删所有人
                ctrlUsers.push(v as any as User);
                return;
            }
            if (adminSet.has(currentUid)) {
                // 管理员只能普通用户
                if (!adminSet.has(v.uid)) {
                    ctrlUsers.push(v as any as User);
                    return;
                } else {
                    return;
                }
            }

        });
        updateUsers(ctrlUsers);
    };

    const initRemoveUserList = async () => {
        const ctrlUsers: User[] = [];
        const result = await groupBlackList({ tid })
        if (result.code == 0 && result.data && result.data.members) {
            members.forEach((v) => {
                if (v.uid === currentUid) {
                    // 不能自己
                    return;
                }
                if (v.uid === group?.uid) {
                    //不能群主
                    return;
                }
                //如果在已经黑名单则不显示
                if (result.data && result.data.members.includes(v.uid)) {
                    ctrlUsers.push(v as any as User);
                }

            });
            updateUsers(ctrlUsers);
        }
    };


    function handleSubmit(members: number[]) {
        postJson("/v1/sdk/group/black/operator", {
            body: { tid: tid, uids: members, type: isRemove ? 1 : 0 }
        }).then((res) => {
            if (!res.code) {
                onClose()
            }
            else {
                res.msg && showToast(res.msg)
            }
        });
    }

    const onClose = () => { navigation.goBack() }

    return (
        <TopicUserListRender
            title={isRemove ? Str_RemoveProhibition : Str_Prohibition}
            users={users}
            onClose={onClose}
            onSubmit={handleSubmit}
            hasRadio={true}
        />
    );
};
